"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ignoreTitlesForSimpleMeasures = void 0;
// (C) 2007-2021 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
/**
 * This function ignores the titles of simple measures.
 *
 * For simple measures, their titles are removed.
 * For adhoc or non-simple measures, their titles are left intact.
 *
 * @param insight - insight or insight definition that must be processed.
 * @returns a copy of insight modified bucket items
 *
 * @internal
 */
function ignoreTitlesForSimpleMeasures(insight) {
    var measuresWithDateFilter = sdk_model_1.insightMeasures(insight, function (measure) { var _a, _b; return (_b = (_a = sdk_model_1.measureFilters(measure)) === null || _a === void 0 ? void 0 : _a.some(sdk_model_1.isDateFilter)) !== null && _b !== void 0 ? _b : false; });
    if (measuresWithDateFilter.length > 0) {
        // If the insight contains a measure with a date filter, all other measures are considered adhoc measures
        // and their titles should be left intact.
        return insight;
    }
    return sdk_model_1.insightModifyItems(insight, function (bucketItem) {
        if (sdk_model_1.isSimpleMeasure(bucketItem) && !sdk_model_1.isAdhocMeasure(bucketItem)) {
            return sdk_model_1.modifyMeasure(bucketItem, function (m) { return m.noTitle(); });
        }
        return bucketItem;
    });
}
exports.ignoreTitlesForSimpleMeasures = ignoreTitlesForSimpleMeasures;
//# sourceMappingURL=ignoreTitlesForSimpleMeasures.js.map